const all = ['patientInformations']
const list = (patientId: number) => [...all, 'list', patientId]
const mutation = [...all, 'mutation']

export const patientInformationsKeys = {
  all,
  list,
  mutation,
}
